/**
 * @generated SignedSource<<922adfdd4940eddfdc0ccb51c247bbb3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PollHeader_data$data = {
  readonly id: string;
  readonly description: {
    readonly title: string;
  };
  readonly reward: {
    readonly formatted: string;
  } | null;
  readonly startDate: string | null;
  readonly " $fragmentType": "PollHeader_data";
};
export type PollHeader_data$key = {
  readonly " $data"?: PollHeader_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"PollHeader_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PollHeader_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuestionDescription",
      "kind": "LinkedField",
      "name": "description",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MoneyAmount",
      "kind": "LinkedField",
      "name": "reward",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatted",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startDate",
      "storageKey": null
    }
  ],
  "type": "PollQuestion",
  "abstractKey": null
};

(node as any).hash = "35f43cc21a53014977ef978b57b69ec7";

export default node;
